import React, { useEffect, useState } from 'react';

import { bootstrapAuthSession } from '@/lib/auth-refresh';
import { Spinner } from '@alfin-crm/ui';

export default function AuthWrapper({ children }: { children: React.ReactNode }) {
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    void bootstrapAuthSession().finally(() => {
      setIsInitializing(false);
    });
  }, []);

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-lg bg-[var(--primary)] flex items-center justify-center text-[var(--primary-fg)] font-medium text-lg">A</div>
          <div className="flex items-center gap-2 text-[var(--fg-muted)] text-sm">
            <Spinner size="sm" />
            Loading Allfin CRM...
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
